import { render, staticRenderFns } from "./FractionsQuiz.vue?vue&type=template&id=83b21576&scoped=true"
import script from "./FractionsQuiz.vue?vue&type=script&lang=js"
export * from "./FractionsQuiz.vue?vue&type=script&lang=js"
import style0 from "./FractionsQuiz.vue?vue&type=style&index=0&id=83b21576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b21576",
  null
  
)

export default component.exports